import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Chain, Config, DAppProvider } from "@usedapp/core";
import { CHAINID, EXPLORER_URL, MULTICALLADDR, RPC_URL } from "./constants/constrants";

    export const TutorialChain: Chain = {
      chainId: CHAINID,
      chainName: 'Metis',
      isTestChain: false,
      isLocalChain: false,
      multicallAddress: MULTICALLADDR,
      multicall2Address: MULTICALLADDR,
      getExplorerAddressLink: (address: string) => `${EXPLORER_URL}/address/${address}`,
      getExplorerTransactionLink: (transactionHash: string) => `${EXPLORER_URL}/tx/${transactionHash}`,
    }
    
    const config: Config = {
          readOnlyChainId: TutorialChain.chainId,
          readOnlyUrls: {
          [TutorialChain.chainId]: RPC_URL
          },
        networks: [TutorialChain],
        }
    
    ReactDOM.render(
      <React.StrictMode>
        <DAppProvider config={config}>
          <App />
        </DAppProvider>
      </React.StrictMode>,
      document.getElementById("root")
    );
